export default "__VITE_ASSET__BoQzlKYz__"